'use strict';
import angular from 'angular';

angular.module('common.services', [])

    .factory('StepsService', ['IORestangular', '$q', function(IORestangular, $q){
        var steps = IORestangular.all('workflows/workflowStep');

        var getSteps = function(){
            return steps.getList();
        };

        var addStep = function(step){
            return steps.customPOST(step, undefined, undefined, undefined);
        };

        var removeStep = function(step){
            return steps.remove(step);
        };

        var updateStep = function(step){
            return steps.customPUT(undefined, undefined, step, undefined);
        };

        return {
            getSteps : getSteps,
            addStep : addStep,
            updateStep : updateStep,
            removeStep : removeStep
        };

    }])
    .factory('StepGroupService', ['IORestangular', function(IORestangular) {
        var stepGroups = IORestangular.all('workflows/workflowStepGroup');
        var stepsRefs = IORestangular.all('workflows/workflowStepGroupXrefs');

        var self = {};

        var getStepGroups = function() {
            return stepGroups.getList();
        };

        var getStepsXrefs = function(id) {
            return stepsRefs.customGET(undefined, id);
        }

        var addStepGroup = function(group) {
            return stepGroups.post(group, undefined, undefined, undefined);
        };

        var updateStepGroup = function(group) {

            return stepGroups.customPUT(undefined, undefined, group, undefined);
            stepGroups.one(group.id).customePUT(group);
        };

        var deleteStepGroup = function(group) {
            return stepGroups.remove(group);
        };

        var addStepToGroup = function(step){
            return stepsRefs.customPOST(undefined, undefined, step, undefined);
        }

        return {
            getStepGroups: getStepGroups,
            addStepGroup: addStepGroup,
            updateStepGroup: updateStepGroup,
            deleteStepGroup: deleteStepGroup,
            getStepsXrefs: getStepsXrefs,
            addStepToGroup: addStepToGroup
        };

    }]);